import FilterBoxList from './FilterBoxList';

export default function SpeciesFilter({
	species,
	isInsidePopup = false,
	filters,
	setFilters
}) {
	return isInsidePopup ? (
		<div class="flex-grow relative">
			<div class="absolute w-full h-full inset-0 overflow-y-scroll">
				<FilterBoxList
					items={species}
					isInsidePopup={true}
					filters={filters}
					setFilters={setFilters}
					filterKey="specieTerms"
				/>
			</div>
		</div>
	) : (
		<FilterBoxList
			items={species}
			filters={filters}
			setFilters={setFilters}
			filterKey="specieTerms"
		/>
	);
}
